import { COLUMNS_GAP_PROGRAM_CARD, PADDING_HORIZONTAL_PROGRAM_CARD, SIZE_ICON_PROGRAM_CARD } from './ProgramCardWrapper';
import { HORIZONTAL_MARGIN_DASHBOARD } from '../../constants/dashboardLayout';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';

export const  useMaxWidthForBadge = () => {
  const {width} = useAvailableDimensions();
  const WIDTH_REMAINING = width - 2*HORIZONTAL_MARGIN_DASHBOARD-COLUMNS_GAP_PROGRAM_CARD-SIZE_ICON_PROGRAM_CARD;
  return(WIDTH_REMAINING- 2* PADDING_HORIZONTAL_PROGRAM_CARD)*0.7;
};